module.exports = __webpack_public_path__ + "static/creative2-bb96377390d00960369a053df137fe58.gif";